namespace Portico.Tfs {
    export class TfsPortalController {
        get isConfigured() {
            return !!this.settings.buildDefinitionId && !!this.settings.releaseDefinitionId;
        }
        get buildDefinitionId() {
            return this.settings.buildDefinitionId;
        }
        get releaseDefinitionId() {
            return this.settings.releaseDefinitionId;
        }
        settings: { buildDefinitionId?: number; releaseDefinitionId?: number } = {};
        constructor(
            private $scope: ng.IScope & { portal: any; },
            private $q: ng.IQService,
            private $interval: ng.IIntervalService,
            private tfsService: TfsService
        ) {
            this.settings = JSON.parse($scope.portal.settings || '{}');

            const interval = $interval(
                () => {
                    this.update();
                },
                30000,
                undefined,
                true
            );
            $scope.$on('destory', () => {
                $interval.cancel(interval);
            });

            $scope.portal.hasBuild =
                !!this.settings.buildDefinitionId && !!this.settings.releaseDefinitionId;

            $scope.$watch<string>('portal.settings', settingsString => {
                this.settings = JSON.parse(settingsString || '{}');
                $scope.portal.hasBuild = this.isConfigured;
                if (this.isConfigured) {
                    this.update();
                }
            });

            if (this.isConfigured) {
                this.update();
            }
        }

        async update() {
            this.updateBuildInformation();
            this.updateReleaseInformation();
            await this.tfsService.getLatestPorticoInformation();
            this.$scope.$broadcast('tfs:update');
        }

        sync() {
            this.tfsService.syncPortal(this.$scope.portal);
            this.$interval(() => this.update(), 5000, 12);
        }

        lastBuild: Build.List.Value;
        lastSuccessfulBuild: Build.List.Value;

        async updateBuildInformation() {
            function getValue(result: Build.List.Response) {
                return result.value[0];
            }

            const [lastSuccessfulBuild, lastBuild] = await this.$q.all([
                this.tfsService.build.list({
                    definitions: this.buildDefinitionId.toString(),
                    resultFilter: 'succeeded',
                    statusFilter: 'completed',
                    $top: 1,
                }),
                this.tfsService.build.list({
                    definitions: this.buildDefinitionId.toString(),
                    $top: 1,
                }),
            ]);
            this.lastBuild = getValue(lastBuild);
            this.lastSuccessfulBuild = getValue(lastSuccessfulBuild);
            if (
                this.lastSuccessfulBuild &&
                this.lastBuild &&
                this.lastSuccessfulBuild.id === this.lastBuild.id
            )
                this.lastSuccessfulBuild = null;
        }

        releases: Release.List.Value[];

        async updateReleaseInformation() {
            const list = await this.tfsService.release.list({
                definitionId: this.releaseDefinitionId,
                $expand: 'environments,artifacts',
            });
            const hasBeenSet = new Set<string>();
            this.releases = list.value;
        }

        onRelease() {
            this.tfsService.build.queue({ definition: { id: this.buildDefinitionId } });
            this.$interval(() => this.update(), 500, 30000 / 500);
        }
    }
    angular
        .module('app')
        .controller('portalTfs', [
            '$scope',
            '$q',
            '$interval',
            'tfsService',
            <any>TfsPortalController,
        ]);
}
